import axios, {AxiosError, AxiosResponse} from 'axios'
import {getAccessTokenForApi, removeAuth} from './AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL

const formDataAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'PUT, POST, DELETE, OPTIONS',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Headers': '*',
  },
})

formDataAxios.interceptors.request.use((config) => {
  const token = getAccessTokenForApi()
  if (token) {
    const prev = config.headers
    const merged =
      typeof prev === 'object' && prev !== null && !Array.isArray(prev)
        ? {...(prev as Record<string, unknown>)}
        : {}
    config.headers = {
      ...merged,
      Authorization: `Bearer ${token}`,
    } as typeof config.headers
  }
  return config
})

formDataAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('expirationTime')
      removeAuth()
    }

    return Promise.reject(error)
  }
)

export default formDataAxios
